import { CdkStepper } from '@angular/cdk/stepper';
import {
  AfterContentInit,
  ChangeDetectionStrategy,
  Component,
  ContentChildren,
  OnDestroy,
  QueryList,
} from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { AtxStep } from '../step/step.component';

@Component({
  selector: 'atx-stepper',
  templateUrl: './stepper.component.html',
  styleUrls: ['./stepper.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [{ provide: CdkStepper, useExisting: AtxStepper }],
  standalone: false,
})
export class AtxStepper
  extends CdkStepper
  implements AfterContentInit, OnDestroy
{
  @ContentChildren(AtxStep, { descendants: true })
  public steps: QueryList<AtxStep>;

  private destroy$ = new Subject<void>();

  public ngAfterContentInit() {
    super.ngAfterContentInit();

    this.steps.changes
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => this._stateChanged());
  }

  public ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  public selectedStepByIndex(index: number) {
    this.selectedIndex = index;
  }

  get isFirstStep() {
    return this.selectedIndex === 0;
  }

  get isLastStep() {
    return this.selectedIndex === this.steps.length - 1;
  }
}
